import { createEntityByIdSource } from 'serviceWorker/channelServers/entitySource';
import * as dbUsers from 'serviceWorker/db/users/users';
import * as dbUsersService from 'serviceWorker/db/users/usersService';
import { userEntityToModel } from 'shared/domain/user/mapping/toModel';
import { userContract } from 'shared/domain/user/userContract';
import { usersSync } from './index';

/** Users of IndexedDB; a model refers to the other users (e.g. who added it). */
export const userSource = createEntityByIdSource({
  service: dbUsersService,
  contract: userContract,
  ...usersSync,
  readAll: async () => {
    const users = await dbUsers.get();
    return users.map((user) => userEntityToModel(user, users));
  },
  readOne: async (id) => {
    const [user, users] = await Promise.all([dbUsers.getOne(id), dbUsers.get()]);
    return user && userEntityToModel(user, users);
  },
});
